var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13.714,
    viewBox: "0 0 12 13.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "discord",
    d: "M7.961,6.514a.7.7,0,1,1-.7-.761A.731.731,0,0,1,7.961,6.514Zm-3.2-.761a.764.764,0,0,0,0,1.522.731.731,0,0,0,.7-.761A.726.726,0,0,0,4.759,5.753ZM12,1.413v12.3c-1.728-1.527-1.175-1.021-3.182-2.887L9.182,12.1H1.406A1.409,1.409,0,0,1,0,10.683V1.413A1.409,1.409,0,0,1,1.406,0h9.189A1.409,1.409,0,0,1,12,1.413Zm-1.954,6.5a9.183,9.183,0,0,0-.987-4A3.391,3.391,0,0,0,7.131,3.2l-.1.11a4.564,4.564,0,0,1,1.707.871,5.826,5.826,0,0,0-5.122-.2c-.254.117-.4.2-.4.2a4.626,4.626,0,0,1,1.8-.9L4.951,3.2a3.391,3.391,0,0,0-1.927.72,9.183,9.183,0,0,0-.987,4A2.486,2.486,0,0,0,4.128,8.955s.254-.309.459-.569a2.133,2.133,0,0,1-1.2-.809c.1.071.267.162.281.171a5,5,0,0,0,4.279.24,3.924,3.924,0,0,0,.789-.4A2.164,2.164,0,0,1,7.495,8.4c.206.261.453.555.453.555a2.507,2.507,0,0,0,2.1-1.042Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.b75ca362d7eb594bc5fdf0db692484ab.svg";
export { ForwardRef as ReactComponent };